module.exports = {"name":"clappr","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.1","built":"2018-05-24","repo":"https://bitbucket.org/npaw/clappr-adapter-js","libVersion":"6.2.6","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getBitrate","getRendition","getIsLive","getResource"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getDuration","getTitle","getResource","getPosition"],"filename":"prerollAdsAdapter.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 15
// module chunks = 0